
import React, { useEffect, useState } from 'react';
import { consultations } from '../../services/api';


export default function ConsultationList() {
  
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState(null);
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [meetLink, setMeetLink] = useState('https://meet.google.com/new');

    useEffect(() => {
        loadRequests();
    }, []);

    async function loadRequests() {
        try {
            const data = await consultations.getPending();
            setRequests(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    async function handleSchedule() {
        if (!date || !time) return alert('Date and Time are required');
        // Combined ISO timestamp logic or simple string, backend expects "date" 
        // Backend migration: scheduled_date TIMESTAMP. 
        // Postgres accepts 'YYYY-MM-DD HH:MM:SS'
        const scheduledDate = `${date} ${time}:00`;

        try {
            await consultations.schedule(selected.id, { date: scheduledDate, link: meetLink });
            alert('Consultation scheduled successfully!');
            setSelected(null);
            setDate('');
            setTime('');
            loadRequests();
        } catch (err) {
            alert('Failed to schedule: ' + (err.response?.data?.error || err.message));
        }
    }

    return (
        <div style={{ padding: 40, marginTop: 64 }}>
            <h2 style={{ color: '#2e7d32', mb: 3 }}>Pending Consultations</h2>

            {loading ? <p>Loading...</p> : (
                <div style={{ background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #eee', overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ background: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                            <tr>
                                <th style={{ padding: 12, textAlign: 'left' }}>Date Requested</th>
                                <th style={{ padding: 12, textAlign: 'left' }}>Patient</th>
                                <th style={{ padding: 12, textAlign: 'left' }}>Status</th>
                                <th style={{ padding: 12, textAlign: 'right' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.length === 0 ? (
                                <tr><td colSpan="4" style={{ padding: 24, textAlign: 'center', color: '#888' }}>No pending requests</td></tr>
                            ) : requests.map(r => (
                                <tr key={r.id} style={{ borderBottom: '1px solid #eee' }}>
                                    <td style={{ padding: 12 }}>{new Date(r.created_at).toLocaleDateString()}</td>
                                    <td style={{ padding: 12 }}>
                                        {r.first_name} {r.last_name} <br />
                                        <span style={{ fontSize: 12, color: '#888' }}>{r.patient_email}</span>
                                    </td>
                                    <td style={{ padding: 12 }}>
                                        <span style={{ background: '#fff3e0', color: '#e65100', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 700 }}>
                                            {r.status}
                                        </span>
                                    </td>
                                    <td style={{ padding: 12, textAlign: 'right' }}>
                                        <button
                                            onClick={() => setSelected(r)}
                                            style={{ background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 12px', cursor: 'pointer' }}
                                        >
                                            Schedule
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal */}
            {selected && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{ background: '#fff', borderRadius: 8, padding: 24, width: 400, maxWidth: '90%' }}>
                        <h3>Schedule Consultation</h3>
                        <p>Patient: <strong>{selected.first_name} {selected.last_name}</strong></p>

                        <div style={{ marginBottom: 16 }}>
                            <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Date</label>
                            <input
                                type="date"
                                value={date}
                                onChange={e => setDate(e.target.value)}
                                style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd' }}
                            />
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Time</label>
                            <input
                                type="time"
                                value={time}
                                onChange={e => setTime(e.target.value)}
                                style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd' }}
                            />
                        </div>

                        <div style={{ marginBottom: 24 }}>
                            <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Meet Link</label>
                            <input
                                type="text"
                                value={meetLink}
                                onChange={e => setMeetLink(e.target.value)}
                                style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd' }}
                            />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                            <button
                                onClick={() => setSelected(null)}
                                style={{ background: 'transparent', border: '1px solid #ddd', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSchedule}
                                style={{ background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}
                            >
                                Confirm Schedule
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
